import React from "react";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import { getPersonFullName, IPerson } from "utils/person";
import { NOT_ACCESSIBLE } from "common/constants";

import useStyles from "./styles";

interface IProps {
  data: racehorse360.IHorseLastPastPerformance;
}

const getStringValueOrNA = (value: string): string => {
  return value?.trim() || NOT_ACCESSIBLE;
};

const ClaimedInfo = (props: IProps) => {
  const { data } = props;

  const classes = useStyles();

  const owner: IPerson = {
    firstName: data.ownerFirstName,
    lastName: data.ownerLastName
  };
  const newOwner: IPerson = {
    firstName: data.newOwnerFirstName,
    lastName: data.newOwnerLastName
  };
  const newTrainer: IPerson = {
    firstName: data.newTrainerFirstName,
    lastName: data.newTrainerLastName
  };
  const ownerValue = getStringValueOrNA(getPersonFullName(owner));
  const newOwnerValue = getStringValueOrNA(getPersonFullName(newOwner));
  const newTrainerValue = getStringValueOrNA(getPersonFullName(newTrainer));
  const price = getStringValueOrNA(
    data.claimedPriceUsa && String(data.claimedPriceUsa)
  );

  return (
    <div className={classes.claimedInfo}>
      {`Claimed by ${newOwnerValue} from ${ownerValue} for $ ${price}.
          ${newTrainerValue} - Trainer`}
    </div>
  );
};

export default React.memo(ClaimedInfo);
